module.exports = __webpack_public_path__ + "img/pao.0e28e9d6.svg";